export enum ProgramType {
  FieldTraining = 1,
  PerformanceEvaluation,
  ProbationaryPeriod,
  Mentoring
}
